<template>
  <div class="DataTableFilteredOnApiProjComponent  DataTables">
    <p>{{lang.infotext_2}}:</p>
    <div :id="id">
      <LoaderComponent  v-if="!isData"></LoaderComponent>
    </div>
    <ContextMenuComponent v-if="isPlugin" :menu="menuPlugin" :id="name"></ContextMenuComponent>
    <ContextMenuComponent v-if="!isPlugin" :menu="menu" :id="name"></ContextMenuComponent>
    <br>
 </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'

var $ = require('jquery');
var jQuery = $
window.$ = $
window.jQuery = $
var jquery = $;

import * as Tools from '@/Tools/Tools';
import dt from 'datatables.net-bs4';





require("datatables.net-select-bs4");
require("datatables.net-keytable");
require("datatables.net-buttons-bs4");
require("@/components/shared/DataTables/jszip.min.js");
var pdfMake = require("pdfmake/build/pdfmake");
var pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

require("@/components/shared/DataTables/buttons.html5.min.js");
require("@/components/shared/DataTables/buttons.print.min.js");
require("@/components/shared/DataTables/buttons.colVis.min.js");

import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'
import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'

import LoaderComponent from "@/components/shared/LoaderComponent"
import ContextMenuComponent from "@/components/shared/ContextMenuComponent"
import { mapGetters } from 'vuex'
export default {
  name: 'DataTableFilteredOnApiProjComponent',
  props:{
    lang: Object
  },
  components: {
    LoaderComponent,
    ContextMenuComponent

  },
  data () {
      return {
        name: "DataTableFilteredOnApiProjComponent",
        id: "tableplace_"+this._uid,
        columns: [],
        colsAssign: [],
        activeActionIds: [],
        contextMenu: {},
        //list of items in the context menu:
        menu: [
          {id: "Details", text: this.lang.contextmenu_text_Details},
          //{id: "Derive", text: this.lang.contextmenu_text_Derive},
          //{id: "Withdraw", text: this.lang.contextmenu_text_Withdraw},
        ],
        menuPlugin: [
          {id: "Place", text: this.lang.contextmenu_text_Place},
          {id: "Derive", text: this.lang.contextmenu_text_Derive},
          
        ],
        visibility: ["NotExposed", "ExposedToTables", "TransferredToDesign", "ForceDisplayed", "ForceHidden"],
        lengthMenu: 20,
      }
  },
  computed: {
    ...mapGetters({

      isPlugin: "isPlugin"

    }),
    categoryId(){
      if (this.$store.getters.selectedTreeProjectItemObject == undefined){
        return 1;
      }else{
        return this.$store.getters.selectedTreeProjectItemObject.categoryId;
      }
    },
    selectedTreeProjectItemObject(){

      return this.$store.getters.selectedTreeProjectItemObject
    },
    activeActions(){

      return this.$store.getters.projm_activeActions
    },
    isData(){

      return false
    },
    /*server(){

      return this.$store.getters.server;
    },*/
    reloadedAfterAction(){
        return this.$store.getters.reloadedAfterAction;
    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    }

  },
  created () {
    this.activeActionIds = [];
    
    for (let i = 0, lei = this.activeActions.length; i < lei; i++){
      
      const obj = {
        actionId: this.activeActions[i].actionId
      }
      this.activeActionIds.push(obj);
    }
    
  },
  watch: {
    categoryId: function(newVal, oldVal){
      
      this.getProperties();
    },
    activeActions: {
      handler: function(newVal, oldVal){

        this.activeActionIds = [];
        for (let i = 0, lei = this.activeActions.length; i < lei; i++){
          
          const obj = {
            actionId: this.activeActions[i].actionId
          }
          this.activeActionIds.push(obj);
        }
        

       
        this.getProperties();
      },
      deep: true
    },
    selectedTreeProjectItemObject: function(newVal, oldVal){

      //this.getProperties();
    },
    reloadedAfterAction: function(newValue, oldValue){

        
      if (newValue.name == this.name){
          if (newValue.status == true){
              
              this.getProperties();
              
              newValue.status = false;
              newValue.name = "";
              this.$store.dispatch("reloadAfterAction", newValue);
          }
      }
        
    }

  },
  updated() {

  },
  mounted: function () {
    
    this.getProperties();


  },
  methods: {
    getProperties(){
      
      let vue = this;

      // let categoryId = 1;
      // if (this.selectedTreeProjectItemObject.categoryId != undefined){
      //   categoryId = this.selectedTreeProjectItemObject.categoryId;
      // }

      // const obj = {
      //   categoryId: categoryId,
      //   actions: this.activeActionIds
      // }

      // this.$store.dispatch(this.$store.getters.sectionPrefix + "_getProperties", obj)
      // .then((result) => {

      //   console.log(result)
      //   //vue.buildColumns(result.data)

      // })

      vue.buildColumns();

    },
    

    buildColumns(properties){
      this.columns = [
          {
            name: "Id",
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          // {
          //   name: this.lang.header_Image,
          //   alignInColumn: "left",
          //   propertyId: "",
          //   type: "image"
          // },
          {
            name: this.lang.header_ProjectNumber,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          {
            name: this.lang.header_ProjectName,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          {
            name: this.lang.header_Revision,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          {
            name: this.lang.header_Status,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          {
            name: this.lang.header_ProjectType,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          {
            name: this.lang.header_ProjectCategory,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          {
            name: this.lang.header_Owner,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          
        ];

      this.colsAssign = [
        { "data": "col___revisionId" },
        { "data": "col___number" },
        { "data": "col___name" },
        { "data": "col___revision" },
        { "data": "col___status" },
        { "data": "col___projectType" },
        { "data": "col___category" },
        { "data": "col___owner" },

      ]
      
      //properties.sort(function(a, b){return a.priority-b.priority});

      // for (let i = 0, lei = properties.length; i < lei; i++){

      //   if (this.selectedTreeProjectItemObject.categoryId == 1){
          
      //     if (properties[i].origins == "own"){
            
      //       let obj = {
      //         name: properties[i].name,
      //         alignInColumn: "left",
      //         propertyId:properties[i].propertyId,
      //         type: properties[i].type,
              
      //       }
      //       this.columns.push(obj);

      //       let objAssign = {
      //         data: "col___"+properties[i].propertyId

      //       }

      //       this.colsAssign.push(objAssign)
      //     }else{
            
      //     }
          
      //   }else{
         
      //     let obj = {
      //       name: properties[i].name,
      //       alignInColumn: "left",
      //       propertyId:properties[i].propertyId,
      //       type: properties[i].type,
            
      //     }
      //     this.columns.push(obj);

      //     let objAssign = {
      //       data: "col___"+properties[i].propertyId

      //     }

      //     this.colsAssign.push(objAssign)
      //   }
        
      // }



      this.buildTable();
    },


    buildTable(){
      

      //let lengthMenu = 20;

      
      
      if (this.$store.getters.outerData != true){
        
        this.$store.dispatch("deleteAllSelectedRows");
        this.$store.dispatch("setOuterData", false);
      }
      
      var tableplace = document.getElementById("tableplace_"+this._uid);
      if (tableplace == null) {
        return;
      }
      while (tableplace.firstChild) {
          tableplace.removeChild(tableplace.firstChild);
      }

      var place = document.createElement("table");
      place.setAttribute("id", "place"+this._uid);
      place.setAttribute("class", "table table-striped table-bordered");
      place.setAttribute("style", "width:100%;");
      tableplace.appendChild(place)

      var tr1 = document.createElement("tr");
      tr1.setAttribute("class", "cellHeader");
      var thead = document.createElement("thead");
      thead.appendChild(tr1);
      place.appendChild(thead);

      var tr2 = document.createElement("tr");
      tr2.setAttribute("class", "cellFooter");
      var tfoot = document.createElement("tfoot");
      tfoot.appendChild(tr2);
      place.appendChild(tfoot);



      var columnDefs = [];


      let _vue = this;

      var len = this.columns.length;

      let y = 0;

      for (let i = 0; i < len; i++){

        let el = {
          targets: i,
          className: '_dt-body-'+ _vue.columns[i].alignInColumn,
          render: function ( data, type, row, meta ) {
            if (data == null) {
              data = "";
            }

            data = $.fn.dataTable.render.text().display(data);
            if (data.display != undefined) {
              data.display = $.fn.dataTable.render.text().display(data.display);
            }

            if (meta.col == 0){
              if (data.name == "revisionId"){
                return  data.revisionId
              }

            }

            let toDisplay = "";
            if (data == undefined){
              
              data = {
                value: {
                  display: "<span style='color:red'>! " + meta.col + "-" + meta.row + "</span"
                }
              }
            }
            
            
            if (data.value != null){
              toDisplay = data.value.display;
            }

            
            if (meta.col == 1){
              
              if (data.name == "number"){
                toDisplay = data.value.display;
              }

            }
            if (meta.col == 2) {

              if (data.name == "name") {
                toDisplay = data.value.display;
              }

            }
            if (meta.col == 4){
              if (data.name == "status"){
                
                let status = "";
                let variant = Tools.getStatusColor(toDisplay);
                status += "<b-badge class='badge badge-"+variant+" '>"+toDisplay+"</b-badge>";
                if (data.used == true){
                  status += "<b-badge class='badge badge-info '>"+_vue.lang.status_Used+"</b-badge>";
                }
                
                return "<div class=\"badges\">"+status+"</div>";
              }
            }
            if (meta.col == 5){
              
              if (data.name == "project type"){
                toDisplay = data.value.display;
              }

            }
            if (meta.col == 6) {

              if (data.name == "category") {
                toDisplay = data.value.display;
              }

            }
            if (meta.col == 7){
              if (data.name == "owner") {
                toDisplay = data.value.display;
              }
              //console.log(data.login)
              //toDisplay = data.login;
              

            }
            
             

            return  toDisplay;
            

  
          }
        }



      columnDefs.push(el);




        var th1 = document.createElement("th");
        
        tr1.appendChild(th1);
        
        var br = document.createElement("br");
        var tx = document.createTextNode(this.columns[i].name);
        th1.appendChild(br);
        th1.appendChild(tx);

      }

        let vue = this;


      var option = {};


      option.keys = false;
      //json.data= datatable;
      option.myColumnFormats = this.columns;
      option.colReorder = false;
      option.lengthMenu = [[20, -1], [20, "All"]];
      option.order = [[ 1, "asc" ]];
      option.select = true;
      option.columns = this.colsAssign;
      option.columnDefs = columnDefs;
      
      option.dom = '<fBlr<t>ip>';
      
      
      option.processing= true;
      option.serverSide= true;
      // option.search = {
      //   regex: true
      // }
      option.initComplete = function (settings, json) {
        

        this.api().columns().every( function () {
          var column = this;

          if (vue.columns[column[0][0]].type != "image"){
            var select = $('<select><option value=""></option></select>')
              .appendTo( $(column.footer()).empty() )
              .on( 'change', function () {

                  var val = $.fn.dataTable.util.escapeRegex(
                      $(this).val()
                  );

                  column
                      .search( val ? val : '', true, false )
                      .draw();
              } );
            let arr = [];
            column.data().unique().sort().each( function ( d, j ) {
              if (d == null){
                return
              }
              
              if (d.value.display != null){

                //if (!arr.includes(d.value.display)){
                  arr.push(d.value.display);
                  select.append( '<option value="' + d.value.display + '">' + d.value.display + '</option>' );
                //}

              }


            });
          }

        });


        
      }
      option.fnDrawCallback = function( oSettings ) {
        
        vue.buildContextMenu();
      }
      option.buttons = [
        {
          extend: 'copy',
          className: 'btn-' + vue.variant,
          exportOptions: {
              columns: ':visible'
          }
        },
        {
          extend: 'print',
          className: 'btn-' + vue.variant,
          messageTop: function () {
            return vue.lang.export_label_top + ": " + vue.$store.getters.selectedTreeProjectItemObject.category;
          },
          exportOptions: {
            columns: ':visible'
          },
          autoPrint: true,
          style: 'fullWidth',
          
          customize: function ( win ) {
              $(win.document.body)
                  .css( 'font-size', '10pt' )
                  

              $(win.document.body).find( 'table' )
                  .addClass( 'compact' )
                  .css( 'font-size', 'inherit' );
          }
        },
        {
          extend: 'csv',
          className: 'btn-' + vue.variant,
          exportOptions: {
            columns: ':visible'
          },
        },
        {
          extend:'excel',
          exportOptions: {
            columns: ':visible'
          },
          className: 'btn-' + vue.variant,
            customize: function ( xlsx ){

            var sheet = xlsx.xl.worksheets['Parts.xml'];


        }},
        {
          extend: 'pdfHtml5',
          messageTop: function () {
                  return vue.lang.export_label_top + ": " + vue.$store.getters.selectedTreeProjectItemObject.category;
          },
          className: 'btn-' + vue.variant,
          exportOptions: {
            columns: ':visible'
          },
          orientation: 'landscape',
          pageSize: 'A4',
          download: 'open',
          
          styles: {
            fullWidth: {
                fontSize: 3,
                bold: true,
                alignment: 'right',
                margin: [0,1900,0,80]		
            },
            subheader: {
                fontSize: 4
            },
            superMargin: {
                margin: [20, 0, 40, 0],
                fontSize: 5,
            }
          },
          customize: function ( doc ) {
            

            doc.pageMargins = [10,10,10,10];
            
            doc.styles.title.fontSize = 9;
            doc.defaultStyle.fontSize = 7;
            doc.styles.tableHeader.fontSize = 9;
            doc.content[0].text = doc.content[0].text.trim();
            
            let numberOfHeaders = columnDefs.length;
            
            if ((numberOfHeaders > 10)&&(numberOfHeaders < 15)){
              
              doc.defaultStyle.fontSize = 5;
              doc.styles.tableHeader.fontSize = 7;
            }else if((numberOfHeaders >= 15)&&(numberOfHeaders < 18)){
              
              doc.defaultStyle.fontSize = 5;
              doc.styles.tableHeader.fontSize = 7;
            }else if(numberOfHeaders >= 18){
              
              doc.defaultStyle.fontSize = 3;
              doc.styles.tableHeader.fontSize = 5;
            }
            
          },
          
        },
        {
        text: 'Json',
        exportOptions: {
          columns: ':visible'
        },
        className: 'btn-' + vue.variant,
            action: function ( e, dt, button, config ) {
                var data = dt.buttons.exportData();

                $.fn.dataTable.fileSave(
                    new Blob( [ JSON.stringify( data ) ] ),
                    'Libraries.json'
                );
            }
        },
        {
          text: 'Reload',
          exportOptions: {
            columns: ':visible'
          },
          className: 'btn-' + vue.variant,
          action: function (e, dt, button, config) {

            vue.mainTable.ajax.reload();
          }

        },
        {
          extend: 'colvis',
          className: 'btn-' + vue.variant,
          
        },
      ];

      option.ajax = {
        url: /*this.server + */"/api/v3/projectmanagement/projects/GetProjects",

        crossDomain: true,
        type: 'POST',
        dataType: 'json',
        cors: true,
        contentType: 'application/json',
        secure: false,
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'POST, GET, OPTIONS'
        },
        error: function (xhr, ajaxOptions, thrownError) {
          // console.log(xhr)
          // console.log(xhr.status)
          // console.log(thrownError)
          if (xhr.responseJSON.message == "Authorization failure."){
            
            vue.$store.dispatch("logout");
          }
          
        },
        data: function ( json ) {
          

          let categoryId = 1;

          if (vue.categoryId != undefined){

            categoryId = vue.categoryId;
          }

          json.categoryId = categoryId;

          let actions = vue.activeActionIds;

          json.actions = actions;

          

          for (let i = 0, lei = json.columns.length; i < lei; i++){
            json.columns[i].col = i;
          }

          //console.log(json)
          
          return JSON.stringify(json);
        },
        dataFilter: function(data){
//todo 

        if (vue.$store.getters.outerData != true){
          vue.$store.dispatch("deleteAllSelectedRows");
          vue.$store.dispatch("setOuterData", false);
        } 
          y = 0;
            var json = jQuery.parseJSON(data);
            //console.log(json)

            let newJson = {
              draw: json.data.draw,
              recordsFiltered: json.data.recordsFiltered,
              recordsTotal: json.data.recordsTotal,
              data: []
            }
            let rows = [];
            vue.lengthMenu = json.data.data.length;
            for (let i = 0, lei = json.data.data.length; i < lei; i++ ) {

              let row = {};
              let objId = {
                projectId: json.data.data[i].projectId,
                revisionId: json.data.data[i].revisionId,
                name: "revisionId",
                type: "text",
                categoryId: json.data.data[i].categoryId,
                categoryName: json.data.data[i].categoryName,
                category: json.data.data[i].category,
                userId: json.data.data[i].userId,
                value: {
                  display: json.data.data[i].revisionId,
                  filter: json.data.data[i].revisionId,
                  sort: json.data.data[i].revisionId
                }
              };

              let revisionId = "col___revisionId";
              row[revisionId] = objId;

              // let objImage = {
              //   projectId: json.data.data[i].projectId,
              //   revisionId: json.data.data[i].revisionId,
              //   name: "image",
              //   type: "image",
              //   categoryId: json.data.data[i].categoryId,
              //   categoryName: json.data.data[i].categoryName,
              //   category: json.data.data[i].category,
              //   used: json.data.data[i].used,
              //   value: {
                  
              //     display: json.data.data[i].imagepath,
              //     filter: json.data.data[i].imagepath,
              //     sort: json.data.data[i].imagepath
              //   }
              // };

              // let image = "col___image";
              // row[image] = objImage;

              let objNumber = {
                projectId: json.data.data[i].projectId,
                revisionId: json.data.data[i].revisionId,
                name: "number",
                type: "project number",
                categoryId: json.data.data[i].categoryId,
                categoryName: json.data.data[i].categoryName,
                category: json.data.data[i].category,
                used: json.data.data[i].used,
                value: {
                  display: json.data.data[i].number == undefined ? json.data.data[i].name: json.data.data[i].number,
                  filter: json.data.data[i].number == undefined ? json.data.data[i].name : json.data.data[i].number,
                  sort: json.data.data[i].number == undefined ? json.data.data[i].name : json.data.data[i].number
                }
              };

              let number = "col___number";
              row[number] = objNumber;

              let objName = {
              projectId: json.data.data[i].projectId,
              revisionId: json.data.data[i].revisionId,
              name: "name",
              type: "project name",
              categoryId: json.data.data[i].categoryId,
              categoryName: json.data.data[i].categoryName,
              category: json.data.data[i].category,
              used: json.data.data[i].used,
              value: {
                display: json.data.data[i].name,
                filter: json.data.data[i].name,
                sort: json.data.data[i].name
              }
            };

            let name = "col___name";
            row[name] = objName;

              let objStatus = {
                projectId: json.data.data[i].projectId,
                revisionId: json.data.data[i].revisionId,
                name: "status",
                type: "text",
                categoryId: json.data.data[i].categoryId,
                categoryName: json.data.data[i].categoryName,
                category: json.data.data[i].category,
                used: json.data.data[i].used,
                login: json.data.data[i].login,
                value: {
                  display: json.data.data[i].status,
                  filter: json.data.data[i].status,
                  sort: json.data.data[i].status
                }
              };

              let status = "col___status";
              row[status] = objStatus;

              let objRevision = {
                projectId: json.data.data[i].projectId,
                revisionId: json.data.data[i].revisionId,
                name: "revision",
                type: "text",
                categoryId: json.data.data[i].categoryId,
                categoryName: json.data.data[i].categoryName,
                category: json.data.data[i].category,
                value: {
                  display: json.data.data[i].revision,
                  filter: json.data.data[i].revision,
                  sort: json.data.data[i].revision
                }
              };

              let revision = "col___revision";
              row[revision] = objRevision;

              let objLibraryType = {
                projectId: json.data.data[i].projectId,
                revisionId: json.data.data[i].revisionId,
                name: "library type",
                type: "text",
                categoryId: json.data.data[i].categoryId,
                categoryName: json.data.data[i].categoryName,
                category: json.data.data[i].category,
                value: {
                  display: json.data.data[i].projectType,
                  filter: json.data.data[i].projectType,
                  sort: json.data.data[i].projectType
                }
              };

              let liraryType = "col___projectType";
              row[liraryType] = objLibraryType;

              let objOwner = {
                projectId: json.data.data[i].projectId,
                revisionId: json.data.data[i].revisionId,
                name: "owner",
                type: "text",
                categoryId: json.data.data[i].categoryId,
                categoryName: json.data.data[i].categoryName,
                category: json.data.data[i].category,
                value: {
                  display: json.data.data[i].login == null?"": json.data.data[i].login,
                  filter: json.data.data[i].login == null ? "" : json.data.data[i].login,
                  sort: json.data.data[i].login == null ? "" : json.data.data[i].login
                }
              };

              let owner = "col___owner";
              row[owner] = objOwner;

              let a = json.data.data[i].category.split("\\");

              a.splice(0, 1);

              let c = a.join('\\');

              let objProjectCategory = {
                projectId: json.data.data[i].projectId,
                revisionId: json.data.data[i].revisionId,
                name: "category",
                type: "text",
                categoryId: json.data.data[i].categoryId,
                categoryName: json.data.data[i].categoryName,
                category: json.data.data[i].category,
                value: {
                  display: c,
                  filter: c,
                  sort: c
                }
              };

              let projectCategory = "col___category";
              row[projectCategory] = objProjectCategory;

              

              rows.push(row);
            }


            newJson.data = rows;

            //console.log(newJson)

            return JSON.stringify(newJson);
          },

        }



          if ($.fn.dataTable.isDataTable('#place'+this._uid)) {
              this.mainTable.destroy();

          }
      
          this.mainTable = $('#place'+this._uid).DataTable(option);
          
          this.mainTable.column( 0 ).visible( false );

          let el = document.getElementsByClassName("dataTables_processing")[0]
          
          if(this.isPlugin){
            el.classList.add("processing-top-plugin");
          }else{
            el.classList.add("processing-top");
          }
          

          //search input change view
          var searchplace = document.getElementById("place"+this._uid+"_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }


          searchplace.firstChild.setAttribute("placeholder", "Enter search words")
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm");
          searchplace.firstChild.addEventListener("input", function(evt){

            _vue.$store.dispatch("setFilteredData", evt.target.value);

          })
          let lengthplace = document.getElementById("place"+this._uid+"_length");
          
          if (lengthplace.firstChild.firstChild != null){
            lengthplace.firstChild.firstChild.nextSibling.setAttribute("class", "form-control form-control-sm select-length");
          }
          
          var stepWait = 0;
          var waitInterval;
          $(".dataTables_filter input")
            .unbind()
            .bind('input', function (e) {
              var item = $(this);
              stepWait = 0;

              if (!waitInterval) {
                waitInterval = setInterval(function () {

                  if (stepWait >= 3) {
                    clearInterval(waitInterval);
                    waitInterval = '';
                    let searchString = $(item).val();
                    _mainTable.search(searchString).draw();
                    stepWait = 0;
                  }
                  stepWait++;
                }, 150);
              }

            });

          let _mainTable = this.mainTable;
          this.mainTable
          .on( 'select', function ( e, dt, type, indexes ) {
              //var rowData = _mainTable.rows( indexes ).data().toArray();
              var rowData = _mainTable.rows( indexes ).data();
              
              
              var count = _mainTable.rows( { selected: true } ).count();
              
              if (_vue.$store.getters.selectedRows.length ==  count - 1 ){
                
              }else{
                
                _vue.$store.dispatch("deleteAllSelectedRows");
              }
              
              _vue.$store.dispatch("setSelectedRows", rowData[0]);
              
              

          })
          .on( 'deselect', function ( e, dt, type, indexes ) {

            for (var i = 0, len = indexes.length; i < len; i++){
              var rowData = _mainTable.rows( indexes[i] ).data();

              
              _vue.$store.dispatch("deleteSelectedRows",rowData[0]);


            }
          });
          
          $('#place'+this._uid+' tbody').on('dblclick', 'tr', function (e) {
            e.stopPropagation() 
            var data = _mainTable.row( this ).data();
            
            _vue.$store.dispatch("deleteAllSelectedRows");
            _vue.$store.dispatch("setSelectedRows", data);
            _vue.$parent.$parent.$parent.$parent.$parent.$parent.details();
          } );

          

      },
      buildContextMenu(){
        

        var _vue = this;

        
        //context-menu
        var tableid = $("#place" + this._uid);

        $("#place" + this._uid + " tbody tr")
        .on("contextmenu", function(e) {
          
          let tr = $(this).closest('tr');
          let row = _vue.mainTable.row( tr );

          let data = row.data();

          _vue.contextMenu.row = data

          

          //methods in table component
          //var updateUser = _vue.updateUser;
          //var deleteUser = _vue.deleteUser;

          _vue.contextMenu.funcAction = function(_vue, action){

            //calling component methods depending on the context menu item clicked
            
            
            if (action == "Details"){
              _vue.$store.dispatch("deleteAllSelectedRows");
              _vue.$store.dispatch("setSelectedRows", data);
              _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.details();
            }
            // if (action == "Derive"){
            //   _vue.$store.dispatch("deleteAllSelectedRows");
            //   _vue.$store.dispatch("setSelectedRows", data);
            //   _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.derive();
            // }
            // if (action == "Withdraw"){
            //   _vue.$store.dispatch("deleteAllSelectedRows");
            //   _vue.$store.dispatch("setSelectedRows", data);
            //   _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.withdraw();
            // }  

            return true;
          }

          var height = tableid.height();

          var offsetX = tableid.offset().left;
          var offsetY = tableid.offset().top;

          var top = e.clientY - offsetY + 170;
          var left = e.clientX - offsetX + 10;

          
          $("#context-menu-"+_vue.name).css({
            display: "block",
            top: top,
            left: left
          });
          return false; //blocks default Webbrowser right click menu
        })
        .on("click", function() {
          
          $("context-menu-"+_vue.name).hide();
        });

        $("#context-menu-"+_vue.name + " a").on("click", function() {
          
          $(this)
            .parent()
            .hide();
        });
        document.addEventListener('click', function(e){
          let clickInside = e.target.closest("#context-menu-"+_vue.name);
          
          if(clickInside == null){
            
            let contextMenu = document.getElementById("context-menu-"+_vue.name);
            if (contextMenu != null){
              contextMenu.setAttribute('style', 'display:none');
            }
                                
          }
        });
        //context-menu
      }


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .DataTableFilteredOnApiProjComponent{
    table{
      font-size: 0.75rem;
      padding: 0px !important;

    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;
      white-space:nowrap;
    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
      position: absolute;
      top: 80px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }
    .processing-top{
      top: 50px;
    }
    .processing-top-plugin{
      //top: 120px;
    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .dataTables_length{
      margin-left: 20px;
      width: 200px;
      float: left;
    }
    .dataTables_length label{
      display: inline-flex;
    }
    .select-length{
      padding: 0.1rem;
      margin-left:10px;
      margin-right:10px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      //margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
      width: 350px;
      float: left;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image-category{
      max-width: 40px;
      //border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      
    }
    .badge{
      margin-right: 1px;
      
      margin-bottom: 2px;
    }
    .badges{
      margin-top: 3px;
      margin-bottom: 2px;
    }
    .image-svg{
      max-width: 40px;
      //border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-right: 3px;
      margin-bottom: 3px;
      background-color: white;
      padding: 2px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/DataTableFilteredOnApiProjComponent.vue